<template>
  <ol class="docs-steps">
    <li>
      On your iPhone open <b>signature.thenoj.com</b> in Safari, fill in your details
      and tap <b>Copy Signature</b>.
    </li>
    <li>
      Open the <b>Settings</b> app and go to <b>Apps → Mail → Signature</b>
      (in the <b>Composing</b> section).
    </li>
    <li>Delete the existing text (e.g. “Sent from my iPhone”), then tap in the field and choose <b>Paste</b>.</li>
    <li>
      The signature will look broken: <b>shake the iPhone</b> and tap <b>Undo</b>
      (“Undo Change Attributes”). This removes the formatting iOS adds and restores the original layout.
    </li>
    <li>Go back, open the <b>Mail</b> app and start a new message to check the result.</li>
  </ol>

  <p class="docs-note">
    If you have multiple accounts you can choose <b>All Accounts</b> or <b>Per Account</b>
    at the top of the Signature screen.
  </p>
</template>
